// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1IBxS","header":"PatientQuestionnaire_header__3dd8J","info":"PatientQuestionnaire_info__3D02m"};